import styled from "styled-components";
import { theme as activeTheme } from "config/themes";
import { ToastData } from "components/shared/Notifications/ToastContext";

export const NotificationContainer = styled.div<{
    type: ToastData["type"];
    positions: ToastData["positions"];
}>`
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: 1000;
    top: ${({ positions: { top, bottom } }) => top && (bottom ? "unset" : `${top}px`)};
    left: ${({ positions: { left } }) => (left ? `${left}px` : "0")};
    right: ${({ positions: { right } }) => (right ? `${right}px` : "0")};
    bottom: ${({ positions: { bottom, top } }) => bottom && (top ? "unset" : `${bottom}px`)};
    margin: auto;
    max-width: 400px;
    min-height: 55px;
    height: 60px;
    padding: 6px;
    border: 1px solid
        ${({ type }) =>
            type === "Success" ? activeTheme.colors.success[700] : activeTheme.colors.error[700]};
    background-color: ${({ type }) =>
        type === "Success" ? activeTheme.colors.success[100] : activeTheme.colors.warning[600]};
    text-align: center;
    box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.1), 0 16px 16px 0 rgba(0, 0, 0, 0.14);
    opacity: 1;
    transition: opacity 0.2s, top 0.2s, visibility 0.2s;

    svg {
        margin-right: 10px;
        height: 25px;
    }
`;
